import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import {Link, BrowserRouter} from 'react-router-dom';
//  import logo from "../assets/img/logo.svg";
 import logo from "../assets/img/software-developer-work-on-computer-programmer-coder-svgrepo-com.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
// import navIcon3 from "../assets/img/nav-icon3.svg";
import navIcon3 from "../assets/img/github-mark-white.svg";

export const Footer = () => {
  return (
    <BrowserRouter>
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <Link to="https://linkedin.com/in/majumdar-shubham">
              <img src={navIcon1} alt="Icon" />
              </Link>
              <Link to="https://www.facebook.com/profile.php?id=100095236946564">
              <img src={navIcon2} alt="Icon" />
              </Link>
              <Link to="https://github.com/smajumdar22">
              <img src={navIcon3} alt="Github" />
              </Link>
            </div>
            <p>Copyright 2023. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
    </BrowserRouter>
  )
}
